const FAQ2 = () => {
    return (
        <div>
            <h3>Buchung</h3>
            <details>
                <summary>Wie kann ich eine Tour buchen?</summary>
                <p>Schicken Sie mir einfach eine Nachricht, in der Sie angeben, welche Tour Sie an welchem Datum buchen möchten. Ich werde Ihnen dann meine Verfügbarkeiten mitteilen, und dann können wir weitermachen.</p>
            </details>
            <details>
                <summary>Muss ich im Voraus bezahlen?</summary>
                <p>Nein, Sie können vor Ort per Interac-Überweisung, PayPal oder in bar bezahlen.</p>
            </details>
            <details>
                <summary>Könnten Sie mir bitte Ihre Verfügbarkeiten mitteilen?</summary>
                <p>Leider habe ich keinen Kalender auf meiner Website. Ich müsste ihn alle zwei Tage aktualisieren. Am besten sagen Sie mir einfach, wann Sie in Montreal sind, und dann teile ich Ihnen mit, an welchen Tagen es mir passt.</p>
            </details>
            <details>
                <summary>Ich habe eine Tour durch das Plateau gebucht, aber es soll viel Regen geben. Kann ich stattdessen den Besuch der unterirdischen Stadt machen?</summary>
                <p>Das ist eine gute Idee! Und auf jeden Fall.</p>
            </details>
        </div>
    )
}

export default FAQ2;